import React from "react";
import CONSTANTS from "../services/constants.service";
import Settings from "../services/settings.service";
import Storage from "../services/storage.service";
// import axios from "axios";
// import "url-search-params-polyfill";
// const HTTPforTracker = axios.create();
import * as variables from "../variables";
import Countries from "../services/countries.service";
import convertCountriesListV2 from "../services/countriesList.service";

var Helpers = {};

Helpers.log = function () {
  if (Settings.debug) {
    for (var i = 0; i < arguments.length; i++) {
      console.log(arguments[i]);
    }
  }
};

Helpers.isMobile600 = () => {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  return w <= 600;
};

Helpers.emptyReject = () => {
  return new Promise((resolve, reject) => {
    reject(false);
  });
};

Helpers.emptyPromise = () => {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
};

Helpers.isAppleSafari = () => {
  let user_agent_str = navigator.userAgent.toLowerCase();
  if (
    user_agent_str.indexOf("mac") !== -1 &&
    user_agent_str.indexOf("safari/") !== -1 &&
    user_agent_str.indexOf("chrome/") === -1
  ) {
    return true;
  } else {
    return false;
  }
};

Helpers.windowWidth = () => {
  return window.innerWidth;
};
Helpers.windowHeight = () => {
  return window.innerHeight;
};

Helpers.debug_payment = function () {
  if (Settings.debug_payment) {
    for (var i = 0; i < arguments.length; i++) {
      console.warn(arguments[i]);
    }
  }
};

Helpers.setCookie = (name, value, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

Helpers.jsonParsable = (val) => {
  return (
    val === "false" ||
    val === "true" ||
    (val.length && val[0] === "{" && val[val.length] === "{") ||
    (val.length && val[0] === "[" && val[val.length] === "]")
  );
};

Helpers.getCookie = (name) => {
  if (document.cookie.indexOf(name + "=") === -1) {
    return "";
  } else {
    var pieces = document.cookie.split(";");
    for (var i = 0; i < pieces.length; i++) {
      var piece = pieces[i];
      if (piece.indexOf(name + "=") !== -1) {
        let result = piece.split("=");
        return result[1];
      }
    }
  }
};

Helpers.windowHeight = () => {
  return window.innerHeight;
};
Helpers.isMobile = () => {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  return w <= 999;
};

Helpers.isSmallDevice = () => {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  return w <= 767;
};

Helpers.luhn = function (number) {
  // var number = 4532814148937827;

  // 1. Convert to string and remove spaces
  number = number.toString().replace(/ /g, "");

  // 2. Split with empty string so it splits character by character
  var pieces = number.split("");

  // pieces = ["4", "5", "3", "2", "8", "1", "4", "1", "4", "8", "9", "3", "7", "8", "2", "7"]
  // In the above array, every item is a string. So we will convert them to number when we want to process on them

  // pop() removes last item and returns it
  var checksum = Number(pieces.pop());

  // Reverse the array for looping convenience
  pieces.reverse();

  var total = 0;

  for (var i = 0; i < pieces.length; i++) {
    // Convert the current number to integer
    pieces[i] = Number(pieces[i]);

    // If alternative number
    if (i % 2 === 0) {
      // Double it
      pieces[i] = pieces[i] * 2;
      // If result is greater than 9 then sum it or else just subtract by 9, the result is same
      if (pieces[i] > 9) {
        pieces[i] -= 9;
      }
    }

    // Add to total for sum of all the numbers
    total += pieces[i];
  }

  // if ((total * 9) % 10 == checksum) {
  // 	Helpers.log("Valid number");
  // } else {
  // 	Helpers.log("Invalid number");
  // }

  return (total * 9) % 10 === checksum;
};

Helpers.sortDefault = (a, b) => {
  return a - b;
};

Helpers.sortByProperty = (property, a, b) => {
  return a[property] - b[property];
};

Helpers.sortByPrice = (a, b) => {
  return a["Price"] - b["Price"];
};

Helpers.sortByFloatProperty = (property, a, b) => {
  return parseFloat(a[property]) - parseFloat(b[property]);
};

Helpers.arrayToKeyedObject = (arr, key) => {
  let obj = {};
  for (let item of arr) {
    obj[item[key]] = item;
  }
  return obj;
};

Helpers.getPaymentReturnURL = (fragment) => {
  if (window.location.hash !== "") {
    return window.location.origin + window.location.pathname + "#/" + fragment;
  } else {
    return window.location.origin + window.location.pathname + fragment;
  }
};

Helpers.getURLPieces = () => {
  let url = window.location.href;
  let all = {};

  all["params"] = "";
  if (url.indexOf("?") !== -1) {
    all["params"] = url.split("?")[1];
    if (all["params"].indexOf("#/") !== -1) {
      all["params"] = all["params"].split("#/")[0];
    }
  }

  all["base"] = "";
  if (url.indexOf("#/") !== -1) {
    all["base"] = url.split("#/")[1];
    if (all["base"].indexOf("?") !== -1) {
      all["params"] = all["base"].split("#/")[0];
    }
  }

  return all;
};

Helpers.receiverPagesExist = () => {
  return (
    window.location.href.indexOf("payfort_token") !== -1 ||
    window.location.href.indexOf("confirmation") !== -1 ||
    window.location.href.indexOf("absher-validation") !== -1 ||
    window.location.href.indexOf("page") !== -1 ||
    window.location.href.indexOf("protection") !== -1 ||
    window.location.href.indexOf("advertisement") !== -1 ||
    window.location.href.indexOf("sim_deactivation") !== -1
  );
};

Helpers.exceptionParamsExist = () => {
  return (
    window.location.href.indexOf("payfort_token") !== -1 ||
    window.location.href.indexOf("unsupported-location") !== -1 ||
    window.location.href.indexOf("delivery-unavailable") !== -1 ||
    window.location.href.indexOf("confirmation") !== -1 ||
    window.location.href.indexOf("absher-validation") !== -1 ||
    window.location.href.indexOf("page") !== -1 ||
    window.location.href.indexOf("protection") !== -1 ||
    window.location.href.indexOf("advertisement") !== -1 ||
    window.location.href.indexOf("sim_deactivation") !== -1
  );
};

Helpers.getNumberWithCountryCode = (number) => {
  if (number.startsWith("00")) {
    number = number.substring(5, number.length);
    number = "966" + number;
  } else if (number.startsWith("0")) {
    number = "966" + number;
  } else {
    if (!number.startsWith("966")) {
      number = "966" + number;
    }
  }
  return number;
};

Helpers.getNumberWithoutCountryCode = (number) => {
  if (number.startsWith("966")) {
    number = number.substring(3, number.length);
    number = "0" + number;
  }
  return number;
};

Helpers.isHTTPS = () => {
  return window.location.href.startsWith("https://");
};

Helpers.forceNonWWW = () => {
  window.location.href = window.location.href.replace(
    "https://www.",
    "https://"
  );
};

Helpers.isWWW = () => {
  return window.location.href.startsWith("https://www.");
};

Helpers.bytesToGBs = (val) => {
  return val / 1073741824;
};

Helpers.generateDeviceID = () => {
  return Math.floor(Math.random() * 10000000000 + 1);
};

Helpers.milisecondstoMinutes = (val) => {
  return val / 1000 / 60;
};

Helpers.toFixedNum = (num, precision) => {
  return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  );
};

Helpers.formatNumber = (number) => {
  let final = Helpers.toFixedNum(parseFloat(number, 10), 2);
  if (final % 1 === 0) {
    final = parseInt(final, 10).toString();
  }
  return final;
};

Helpers.paddingPhoneNumber = (number) => {
  let phoneNumber = number;
  if (phoneNumber.indexOf(variables.INTERNATIONAL_INIT_CODE) !== -1) {
    phoneNumber = phoneNumber.replace(variables.INTERNATIONAL_INIT_CODE, 0);
  }
  return `${phoneNumber.substr(0, 3)} ${phoneNumber.substr(
    3,
    3
  )}  ${phoneNumber.substring(6)}`;
};

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Helpers.formatCurrency = (number) => {
  return numberWithCommas(number);
};

Helpers.arrayToObject = (array, keyField) => {
  return array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});
};

Helpers.objectToArray = (object, keyField) => {
  let keys = Object.keys(object);
  let arr = [];
  for (let key of keys) {
    arr.push(object[key]);
  }
  return arr;
};

Helpers.arrayToObjectSingleCol = (array) => {
  return array.reduce((obj, item) => {
    obj[item + ""] = item;
    return obj;
  }, {});
};

Helpers.capitalize = (str, lower) => {
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

Helpers.getStorageParams = (key) => {
  let params = window.localStorage.getItem(key);
  window.localStorage.removeItem(key);
  if (params) {
    return JSON.parse(params);
  }
  return params;
};

Helpers.getUserSelection = () => {
  return Helpers.getStorageParams("user_selection");
};

Helpers.getUserSelectionByKey = (key) => {
  const userSelection = Helpers.getStorageParams("user_selection");
  if (userSelection && typeof userSelection[key] !== "undefined") {
    return userSelection[key];
  }
  return null;
};

Helpers.clearUserSelectionFlags = () => {
  window.localStorage.removeItem("user_selection");
};

Helpers.getParams = () => {
  let params = {
    string: "",
    pieces: {},
  };
  if (window) {
    if (window.location.href.indexOf("?") !== -1) {
      let search = window.location.href.substring(
        window.location.href.indexOf("?") + 1
      );

      if (search.indexOf("#") !== -1) {
        search = search.substring(0, search.indexOf("#"));
      }

      params.string = search;
      search = search.split("&");

      for (let v = 0; v < search.length; v++) {
        let pair = search[v].split("=");
        params.pieces[pair[0]] = pair[1];
      }
    }
  }
  return params;
};

// datepart: 'y', 'm', 'w', 'd', 'h', 'n', 's'
Helpers.dateDiff = (datepart, fromdate, todate) => {
  datepart = datepart.toLowerCase();
  let diff = todate - fromdate;
  let divideBy = { w: 604800000, d: 86400000, h: 3600000, n: 60000, s: 1000 };

  return Math.floor(diff / divideBy[datepart]);
};

Helpers.monthsInDay = (days) => {
  if (days <= 45) {
    return 1;
  } else {
    let durationCutOff = days - 15;
    if (durationCutOff % 30 === 0) {
      return Math.floor(durationCutOff / 30);
    } else {
      return Math.floor(durationCutOff / 30 + 1);
    }
  }
};

Helpers.removeLeadingZeros = (num) => {
  // traverse the entire string
  for (var i = 0; i < num.length; i++) {
    // check for the first non-zero character
    if (num.charAt(i) !== "0") {
      // return the remaining string
      let res = num.substr(i);
      return res;
    }
  }

  // If the entire string is traversed
  // that means it didn't have a single
  // non-zero character, hence return "0"
  return "0";
};

Helpers.getStreaminService = () => {
  let business = Storage.get("business", true);
  let streaming = [];
  if (business) {
    business = JSON.parse(business);
    streaming = business?.stf_content_services_web;
  }
  return streaming;
};

Helpers.formatWithPO = (number) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    const roundUp = new Intl.NumberFormat("en", {
      maximumFractionDigits: business.price_max_fraction_digits,
      minimumFractionDigits: business.price_min_fraction_digits,
    }).format(number);
    return roundUp;
  }
  return number;
};

Helpers.formatWithPORemoveCommas = (number) => {
  return Helpers.formatWithPO(number).replaceAll(",", "");
};

Helpers.checkForProductDetail = (type, staticValue) => {
  // type (Key): name, staticValue (Value): "Regular"
  // product_categories_with_codes
  let business = Storage.get("business", true);
  let productDetails = [];
  if (business) {
    business = JSON.parse(business);
    if (business?.product_categories_with_codes) {
      productDetails = business.product_categories_with_codes;
    }
  }
  if (type === "code") {
    return productDetails.find(
      (product) => Number(product[type]) === Number(staticValue)
    );
  }
  return productDetails.find((product) => product[type] === staticValue);
};

Helpers.getProductAttribute = () => {
  // Fetch the Product Attribute from the PO based on the Product Code
  const ActiveProductCodes = Storage.get(
    "pre-defined-plan-selected-product-code",
    true
  );
  let productAttribute = "Regular";
  const checkForProductDetail = Helpers.checkForProductDetail(
    "code",
    ActiveProductCodes
  );
  if (checkForProductDetail?.type) {
    productAttribute = checkForProductDetail.type;
  }
  return productAttribute;
};

Helpers.getProductAttributebyPC = (activeProductCodes) => {
  // Fetch the Product Attribute from the PO based on the Product Code
  let productAttribute = "Regular";
  const checkForProductDetail = Helpers.checkForProductDetail(
    "code",
    activeProductCodes
  );
  if (checkForProductDetail?.type) {
    productAttribute = checkForProductDetail.type;
  }
  return productAttribute;
};

Helpers.getProductCode = (productAttribute) => {
  // Get product code from PO by Product name.
  const checkForProductDetail = Helpers.checkForProductDetail(
    "name",
    productAttribute
  );
  if (checkForProductDetail?.code) {
    return checkForProductDetail.code;
  } else {
    return "";
  }
};

Helpers.isPlanPostPaidByPC = () => {
  // Works on the basis of data stored locally from the API.
  const checkForProductDetail = Helpers.checkForProductDetail(
    "name",
    CONSTANTS.REGULAR_POSTPAID_PRODUCT_ATTR
  );
  let productCode = Storage.get("pre-defined-plan-selected-product-code", true);
  if (checkForProductDetail?.code) {
    if (Number(productCode) === Number(checkForProductDetail.code)) {
      return true;
    }
  }
  return false;
};

Helpers.isPlanPostPaidDynamic = (productCode) => {
  // Works on the basis of data coming directly from the API.
  const checkForProductDetail = Helpers.checkForProductDetail(
    "name",
    CONSTANTS.REGULAR_POSTPAID_PRODUCT_ATTR
  );
  if (checkForProductDetail?.code) {
    if (Number(productCode) === Number(checkForProductDetail.code)) {
      return true;
    }
  }
  return false;
};

Helpers.checkSimOptionAvailability = (type) => {
  let enable = true;
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    if (business["sim_selection_options"]) {
      const simSelectionData = business["sim_selection_options"];
      enable = simSelectionData[type];
    }
  }
  return enable;
};

Helpers.getOTPLength = (key) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    return business[key] || 6;
  } else {
    return 6;
  }
};

Helpers.getOTPTimer = (key) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    return business[key] || 30;
  } else {
    return 30;
  }
};

Helpers.getTestingIDs = () => {
  let business = Storage.get("business", true);
  let streaming = [];
  if (business) {
    business = JSON.parse(business);
    streaming = business?.eligibility_test_ids || streaming;
  }
  return streaming;
};

Helpers.checkEnableFlag = (key) => {
  let business = Storage.get("business", true);
  let enabled = true;
  if (business) {
    business = JSON.parse(business);
    enabled = business[key] || enabled;
  }
  return enabled;
};

Helpers.getPlanCode = (planDetails, fetchFrom = "Direct") => {
  let planCode = "";
  switch (fetchFrom) {
    case "ExtraDetails":
      if (planDetails) planCode = JSON.parse(planDetails)?.PlanCode;
      break;
    case "Direct":
      planCode = planDetails;
      break;
    default:
      break;
  }
  return planCode;
};

Helpers.processPlanCode = (planDetails, fetchFrom = "Direct") => {
  try {
    const planCode = Helpers.getPlanCode(planDetails, fetchFrom);
    if (planCode) {
      const planKey = planCode
        ?.replaceAll("-", "_")
        ?.replaceAll(" ", "")
        ?.replaceAll(",", "_")
        ?.toLowerCase();
      return planKey || "";
    } else {
      return "";
    }
  } catch (error) {
    console.error("Error in processPlanCode:", error); // Log any error that occurs
    return ""; // Return an empty string in case of error
  }
};

Helpers.convertCountriesList = () => {
  const newCountriesList = {};
  let countries = Countries.Countries;
  for (const [iso2, details] of Object.entries(countries)) {
    newCountriesList[details.CountryName] = {
      CountryCode: details.CountryCode,
      CountryName: details.CountryName,
      ISO_2Code: iso2,
      ISO_3Code: details.ISO_3Code,
      CountryName_ar: details.CountryName_ar,
    };
  }

  return newCountriesList;
};

Helpers.convertCountriesListV2 = () => {
  let countries = convertCountriesListV2.Countries;

  return countries.reduce((acc, country) => {
    // Destructure the needed properties from the country object
    const { nationality, name, iso_2code, iso_3code, dial_code } = country;

    // Add the country object to the accumulator with the nationality as the key
    acc[nationality] = {
      name,
      iso_2code,
      iso_3code,
      dial_code,
      nationality,
    };

    return acc;
  }, {});
};

Helpers.convertCountriesListBasedOn = (iso_code = false) => {
  let countries = convertCountriesListV2.Countries;
  return countries.reduce((acc, country) => {
    // Destructure the needed properties from the country object
    const { nationality, name, iso_2code, iso_3code, dial_code } = country;

    // Add the country object to the accumulator with the nationality as the key
    acc[iso_code ? iso_3code : iso_2code] = {
      name,
      iso_2code,
      iso_3code,
      dial_code,
      nationality,
    };

    return acc;
  }, {});
};

// Helpers.arrConvertCountriesListBasedOn = () => {
//   let countries = convertCountriesListV2.Countries;
//   return countries.map(country => {
//     // Destructure the needed properties from the country object
//     const { nationality, name, iso_2code, iso_3code, dial_code } = country;

//     // Return an object with the desired properties
//     return {
//       name,
//       iso_2code,
//       iso_3code,
//       dial_code,
//       nationality
//     };
//   });
// }

Helpers.validateFirstName = (firstName, allowedTyping = true) => {
  // Currently, Not in Use
  // Check if the input starts with a space
  let valid = true;
  let minLength = 3;
  let maxLength = 20;

  if (firstName.startsWith(" ")) {
    // "The first name should not start with a space.";
    valid = false;
    return valid;
  }

  // Regular expression to match valid characters (letters and spaces)
  const validNamePattern = /^[A-Za-z ]+$/;

  // Test the input against the regular expression
  if (!validNamePattern.test(firstName)) {
    // "The first name should only contain letters and spaces.";
    valid = false;
    return valid;
  }

  // Check the length of the input
  if (firstName.length > maxLength) {
    // "The first name should be between ${minLength} and ${maxLength} characters long.";
    valid = false;
    return valid;
  }

  if (allowedTyping) {
    // Check the length of the input
    if (firstName.length < minLength) {
      // "The first name should be between ${minLength} and ${maxLength} characters long.";
      valid = false;
      return valid;
    }
  }

  // If all validations pass
  return valid;
};

Helpers.commonValidateChecker = (value, validation) => {
  // Check if the input starts with a space
  let valid = true;

  // Check the length of the input
  if (validation.type === "minLength" && value.length < validation.value) {
    // "The last name should be between ${minLength} and ${maxLength} characters long.";
    valid = false;
    return { valid: valid, errorType: validation.type };
  }

  return { valid: true, errorType: "" };
};

Helpers.inputChar = (event, limit = 20) => {
  // const re = /^[0-9]{0,10}$/
  const re = /^[A-Za-z ]+$/;
  return (
    event.target.value === "" ||
    (event.target.value.length <= limit && re.test(event.target.value))
  );
};

Helpers.shouldSimahShowFields = (field) => {
  let productCode = Storage.get("pre-defined-plan-selected-product-code", true);
  let business = Storage.get("business", true);
  let simahFields = [];
  if (business) {
    business = JSON.parse(business);
    let poKeySuffix = Settings?.poKeySuffix || "";
    if (
      business[
        `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
      ]
    ) {
      simahFields =
        business[
          `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
        ];
    }
  }
  // Find the simahFields that matches the given product code
  if (simahFields.length > 0) {
    const config = simahFields?.find(
      (c) => c?.product_code?.toString() === productCode?.toString()
    );
    if (config) {
      // Return true if any field should be shown, otherwise false
      return config[field];
    } else {
      // Return false if no configuration is found for the product code
      return false;
    }
  } else {
    return false;
  }
};

Helpers.getEligbilityPOValueObject = (field) => {
  let productCode = Storage.get("pre-defined-plan-selected-product-code", true);
  let business = Storage.get("business", true);
  let simahFields = [];
  if (business) {
    business = JSON.parse(business);
    let poKeySuffix = Settings?.poKeySuffix || "";
    if (
      business[
        `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
      ]
    ) {
      simahFields =
        business[
          `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
        ];
    }
  }
  // Find the simahFields that matches the given product code
  if (simahFields.length > 0) {
    const config = simahFields?.find(
      (c) => c?.product_code?.toString() === productCode?.toString()
    );
    if (config) {
      // Return true if any field should be shown, otherwise false
      return config[field];
    } else {
      // Return false if no configuration is found for the product code
      return 0;
    }
  } else {
    return 0;
  }
};

Helpers.shouldShowAnySimahField = () => {
  let productCode = Storage.get("pre-defined-plan-selected-product-code", true);
  let business = Storage.get("business", true);
  let simahFields = [];
  if (business) {
    business = JSON.parse(business);
    let poKeySuffix = Settings?.poKeySuffix || "";
    if (
      business[
        `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
      ]
    ) {
      simahFields =
        business[
          `eligibility_data_fields${poKeySuffix}` || "eligibility_data_fields"
        ];
    }
  }
  // Find the simahFields that matches the given product code
  if (simahFields.length > 0) {
    const config = simahFields?.find(
      (c) => c?.product_code?.toString() === productCode?.toString()
    );
    if (config) {
      // Return true if any field should be shown, otherwise false
      return true;
    } else {
      // Return false if no configuration is found for the product code
      return false;
    }
  } else {
    return false;
  }
};

Helpers.checkEnableTopup = (key) => {
  let business = Storage.get("business", true);
  let enabled = false;
  if (business) {
    business = JSON.parse(business);
    enabled = business[key] || enabled;
  }
  return enabled;
};

Helpers.checkEnableSocialLogin = (key) => {
  let business = Storage.get("business", true);
  let enabled = false;
  if (business) {
    business = JSON.parse(business);
    enabled = business[key] || enabled;
  }
  return enabled;
};

Helpers.commonPhoneValidateChecker = (value, validation) => {
  let valid = true;
  // Check if required
  if (validation.required && value.trim() === "") {
    return { valid: false, errorType: "required" };
  }

  // Check the length of the input
  if (validation.minLength && value.length < validation.minLengthValue) {
    valid = false;
    return { valid: valid, errorType: "minLength" };
  }

  if (validation.phoneNumber) {
    let business = Storage.get("business", true);
    let numberRegex = "";
    let valid = true;
    if (business) {
      business = JSON.parse(business);
      numberRegex = business?.phone_number_regex;
      if (numberRegex) {
        const reg = new RegExp(numberRegex);
        valid = reg.test(value);
      }
    }
    return { valid: valid, errorType: "number" };
  }

  return { valid: true, errorType: "" };
};


Helpers.commonPhoneValidateCheckerHBB = (value, validation) => {
  let valid = true;
  // Check if required
  if (validation.required && value.trim() === "") {
    return { valid: false, errorType: "required" };
  }

  // Check the length of the input
  if (validation.minLength && value.length < validation.minLengthValue) {
    valid = false;
    return { valid: valid, errorType: "minLength" };
  }

  // Accept only 10 or 15 digit numbers
  if (validation.phoneNumber) {
    const len = value.length;
    const isValidLength = (len === 10 || len === 15);
    if (!isValidLength) {
      return { valid: false, errorType: "length" };
    }
    // optional regex (if business regex exists)
    let business = Storage.get("business", true);
    if (business) {
        try {
            business = JSON.parse(business);
            const numberRegex = business?.phone_number_regex;
            if (numberRegex) {
                const reg = new RegExp(numberRegex);
                if (!reg.test(value)) {
                    return { valid: false, errorType: "number" };
                }
            }
        } catch (_) { }
    }
    return { valid: true, errorType: "" };
  }

  return { valid: true, errorType: "" };
};

Helpers.getCountryCodePO = () => {
  let business = Storage.get("business", true);
  let code = "";
  if (business) {
    business = JSON.parse(business);
    code = business?.msisdn_syntax_validation_country_code || code;
  }
  return code;
};

Helpers.CheckEnableTapPayment = () => {
  let business = Storage.get("business", true);
  let enable_tap_payment = false;
  if (business) {
    business = JSON.parse(business);
    enable_tap_payment = business?.enable_tap_payment || enable_tap_payment;
  }
  return enable_tap_payment;
};

Helpers.commonAmountValidateChecker = (value, validation) => {
  let valid = true;
  // Check if required
  if (validation.required && value.trim() === "") {
    return { valid: false, errorType: "required" };
  }

  // Check the min amount of the input
  if (validation.minAmount && value < validation.minAmountValue) {
    valid = false;
    return { valid: valid, errorType: "minAmount" };
  }

  // Check the max amount of the input
  if (validation.maxAmount && value > validation.maxAmountValue) {
    valid = false;
    return { valid: valid, errorType: "maxAmount" };
  }

  return { valid: true, errorType: "" };
};

Helpers.getPOValue = (key, prefilled) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    return business[key] || prefilled;
  } else {
    return prefilled;
  }
};

Helpers.getPlanTypeUnitLokaliseKey = (planType) => {
  let ele = "";
  switch (planType) {
    case "DATA":
      ele = "stm_general_data_unit";
      break;
    case "DATA-SOCIAL":
      ele = "stm_general_data_unit";
      break;
    case "DATA-ROM":
      ele = "stm_general_data_unit";
      break;
    case "VOICE-IN-ROM":
      ele = "stm_general_minute_unit";
      break;
    case "VOICE-INT":
      ele = "stm_general_minute_unit";
      break;
    case "VOICE-LCL":
      ele = "stm_general_minute_unit";
      break;
    case "VOICE-FLEXI":
      ele = "stm_general_flexi_minute_unit"
      break;
    case "SMS-LCL":
      ele = "stm_general_sms_unit";
      break;
    default:
      ele = "stm_general_unknown_unit"
      break;
  }
  return ele;
};

Helpers.getDynamicClass = (sortedPlanDataFirstRow) => {
  let classString = "";
  switch (sortedPlanDataFirstRow) {
    case "1":
    case 1:
      classString = "one-items";
      break;
    case "2":
    case 2:
      classString = "two-items";
      break;
    case "3":
    case 3:
      classString = "three-items";
      break;
    default:
      break;
  }
  return classString;
};

Helpers.getDynamicClassForFirstRow = (
  sortedPlanDataFirstRow,
  sortedPlanDataSecondRow
) => {
  if (sortedPlanDataFirstRow < 3 && sortedPlanDataSecondRow > 0) {
    return "flat-items";
  } else if (sortedPlanDataFirstRow < 3 && sortedPlanDataSecondRow === 0) {
    return "non-flat-items no-second-row";
  } else {
    return "non-flat-items";
  }
};

Helpers.handleProductCode = (type) => {
  Storage.clear("user_selection");
  const checkForProductDetail = Helpers.checkForProductDetail("name", type);
  if (checkForProductDetail?.code) {
    Storage.set(
      "pre-defined-plan-selected-product-code",
      checkForProductDetail?.code,
      true
    );
  }
};

Helpers.isValidIDNumber = (nicNumber) => {
  // Check If nicNumber is a TestID
  const testIDs = Helpers.getTestingIDs();
  if (testIDs?.includes(parseInt(nicNumber))) return true;

  var prefix = "12";
  var outNumber = parseInt(nicNumber);

  if (nicNumber.length === 0) {
    return false;
  }

  // Bypass Eligibility Checking
  const enableIsValidIDNumber = Helpers.checkEnableFlag(
    "enable_eligibility_id_validation"
  );
  if (!enableIsValidIDNumber) return true;

  if (
    nicNumber.length !== 10 ||
    isNaN(outNumber) ||
    prefix.indexOf(nicNumber[0]) < 0
  ) {
    return false;
  }
  var charArray = nicNumber.split("");
  var numArray = new Array(10);
  for (var k = 0; k < charArray.length; k++) {
    numArray[k] = parseInt(charArray[k]);
  }
  var sum = 0;
  for (var i = 0; i < numArray.length - 1; i++) {
    if (i % 2 !== 0) {
      sum += numArray[i];
    } else {
      var oddByTwo = numArray[i] * 2;
      var oddByTwoString = oddByTwo.toString();
      var oddByTwoArray = new Array(oddByTwoString.length);
      var oddByTwoSum = 0;
      for (var j = 0; j < oddByTwoArray.length; j++) {
        oddByTwoArray[j] = parseInt(oddByTwoString[j]);
        oddByTwoSum += oddByTwoArray[j];
      }
      sum += oddByTwoSum;
    }
  }
  var sumString = sum.toString();
  var unit = parseInt(sumString[sumString.length - 1]);
  if ((unit === 0 && numArray[9] === 0) || 10 - unit === numArray[9]) {
    return true;
  }
  return false;
};

Helpers.isValidIBAN = (ibanNumber) => {
  let regexString = Helpers.getPOValue(
    "iban_regex",
    "^[A-Za-z]{2}[0-9]{2}[A-Za-z0-9]{1,34}$"
  );
  let ibanRegex = new RegExp(regexString);
  if (ibanRegex.test(ibanNumber)) {
    return false;
  }
  return true;
};

Helpers.inputAlphaNumeric = (event, limit = 34) => {
  const re = /^[a-zA-Z0-9]+$/;
  return (
    event.target.value === "" ||
    (event.target.value.length <= limit && re.test(event.target.value))
  );
};

Helpers.commonValidateChecker = (value, validation) => {
  // Check if the input starts with a space
  let valid = true;

  // Check if the input is empty
  if (value.trim() === "") {
    valid = false;
    return { valid: valid, errorType: "required" };
  }

  // Check the length of the input
  if (validation.type === "minLength" && value.length < validation.value) {
    // "The last name should be between ${minLength} and ${maxLength} characters long.";
    valid = false;
    return { valid: valid, errorType: validation.type };
  }

  if (validation.type === "maxLength" && value.length > validation.value) {
    // "The last name should be between ${minLength} and ${maxLength} characters long.";
    valid = false;
    return { valid: valid, errorType: validation.type };
  }

  return { valid: true, errorType: "" };
};

Helpers.processLokaliseKey = (keyName, replaceSpacesWithUnderscore = false) => {
  if (keyName) {
    let planKey = keyName?.replaceAll("-", "_")?.replaceAll(",", "_");

    // Replace spaces depending on the setting
    if (replaceSpacesWithUnderscore) {
      planKey = planKey.replaceAll(" ", "_");
    } else {
      planKey = planKey.replaceAll(" ", "");
    }

    return planKey?.toLowerCase() || "";
  } else {
    return "";
  }
};

Helpers.isSafari = () => {
  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari;
};

Helpers.nextLineText = (textString, Component = "p") => {
  const brokenText = textString?.split("\n");
  return brokenText?.map((item, index) => {
    return <Component key={index}>{item}</Component>;
  });
};

Helpers.getPOImageCommon = (po_folder_name, keyName, lang, size = "") => {
  // po_folder_name: Folder to fetch the images
  // key: Appended/Non-Appended with size like _small, _web, etc.
  // lang: 'en', 'ar'
  let key = `${keyName}${size}`;
  let requiredPoImage = "";
  // Fetch the Images Folder
  const poImage = Storage.get(po_folder_name, true);
  // Check if poImage is valid JSON
  let parsedPoImage = {};
  try {
    if (poImage && poImage !== "undefined") {
      parsedPoImage = JSON.parse(poImage);
    }
  } catch (error) {
    console.log("Error parsing PO Image:", error);
    return requiredPoImage; // Return empty string on error
  }
  // Build keys for localized and default image fetching
  const keyWithLang = `${key}_${lang}`;

  const keyUrlWithLang = parsedPoImage[keyWithLang]?.url;
  const keyUrlWithoutLang = parsedPoImage[key]?.url;
  const defaultUrl = parsedPoImage[`default${size}`]?.url;
  requiredPoImage = keyUrlWithLang || keyUrlWithoutLang || defaultUrl || "";
  return requiredPoImage; // Return the determined image URL
};

Helpers.getFeatureDisabled = (type) => {
  let business = Storage.get("business", true);
  let enabled = true;
  if (business) {
    business = JSON.parse(business);
    if (business[type] === undefined) {
      enabled = true;
    } else {
      enabled = business[type];
    }
  }
  return enabled;
};

Helpers.updateAPIString = (inputString) => {
  const updatedString = `${inputString
    .toLowerCase()
    .replaceAll(" ", "_")
    .replaceAll("-", "_")}`;
  return updatedString;
};

Helpers.filterByPlanType = (data, type) => {
  return data?.filter((plan) => plan?.Type === type);
};

Helpers.clearKeysFromSessionStorage = (keysToClear = []) => {
  keysToClear.forEach((key) => {
    sessionStorage.removeItem(key);
  });
};

Helpers.normalizePhoneNumber = (msisdn) => {
  msisdn = msisdn.toString();

  if (!msisdn.startsWith("966")) return null;

  let normalized = msisdn.startsWith("9660") ? "966" + msisdn.slice(4) : msisdn;

  if (/^9665\d{8}$/.test(normalized)) {
    return normalized;
  }

  return null;
};

Helpers.byPassReservationScreen = () => {
  Storage.clear("TabSwitched");
  sessionStorage.clear("TabSwitchedBack");
}
Helpers.getSelectedUserSimNumber = () => {
  const number = Storage.get("number", true);
  return number || "";
};

Helpers.getStorageValue = (key) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    let poValue = business[key] ? business[key] : "";
    return poValue ? poValue : "";
  }
  return "";
};

Helpers.getStorageBooleanValue = (key) => {
  const value = Helpers.getStorageValue(key);
  return value === true;
};

Helpers.renderCurrencySymbolWithPrice = (price, lokaliseString) => {
  let currencyUniCode = "\uE900";
  let currency_symbol_data = Helpers.getPOValue("currency_symbol_data_v2", {});
  let alignLeft = currency_symbol_data?.show_currency_left || false;
  let currencySymbolEnable = currency_symbol_data?.currency_symbol_enable || false;
  let regex = new RegExp(currency_symbol_data?.currency_code_regex, 'g');
  let currency_code_regex = false;
  if(currency_symbol_data?.currency_code_regex) {
    currency_code_regex = lokaliseString.match(regex);
  }

  if(currency_code_regex && currencySymbolEnable) {
    if(alignLeft) {
      return <><span className="has-currency-symbol">{currencyUniCode}</span>{price}</>
    } else {
      return <>{price}{" "}<span className="has-currency-symbol">{currencyUniCode}</span></>  
    }
  } else {
    if(alignLeft) {
      return <><span className="general-currency-symbol">{lokaliseString}</span>{" "}{price}</>
    } else {
      return <>{price}{" "}<span className="general-currency-symbol">{lokaliseString}</span></>  
    }
  }
}

Helpers.renderCurrencySymbolReplace = (lokaliseString) => {
  let currencyUniCode = "\uE900";
  let currency_symbol_data = Helpers.getPOValue("currency_symbol_data_v2", {});
  let currency_code_regex = currency_symbol_data?.currency_code_regex;
  if(currency_code_regex) {
    currency_code_regex = new RegExp(currency_code_regex, 'g');
  }
  // If the string contains any of the currency codes, replace them
  if (currency_code_regex?.test(lokaliseString)) {
    return lokaliseString?.split(currency_code_regex)?.map((part, index) => {
      if (currency_code_regex?.test(part)) {
        return <span key={index} className="has-currency-symbol">{currencyUniCode}</span>;
      }
      return part;
    });
  } else {
    return <>{lokaliseString}</>;
  }
};

Helpers.renderCurrencySymbolWithPricePlaceholder = (price, lokaliseString) => {
  let currencyUniCode = '\uE900';
  let currency_symbol_data = Helpers.getPOValue("currency_symbol_data_v2", {});
  let alignLeft = currency_symbol_data?.show_currency_left || false;
  let currencySymbolEnable = currency_symbol_data?.currency_symbol_enable || false;
  let regex = new RegExp(currency_symbol_data?.currency_code_regex, 'g');
  let currency_code_regex = false;
  if(currency_symbol_data?.currency_code_regex) {
    currency_code_regex = lokaliseString.match(regex);
  }

  if(currency_code_regex && currencySymbolEnable) {
    if(alignLeft) {
      return <><span className="has-currency-symbol">{currencyUniCode}</span><span className="has-currency-price">{price}</span></>
    } else {
      return <><span className="has-currency-price">{price}</span>{" "}<span className="has-currency-symbol">{currencyUniCode}</span></>  
    }
  } else {
    if(alignLeft) {
      return <><span className="general-currency-symbol">{lokaliseString}</span>{" "}<span className="has-currency-price">{price}</span></>
    } else {
      return <><span className="has-currency-price">{price}</span>{" "}<span className="general-currency-symbol">{lokaliseString}</span></>  
    }
  }
} 

Helpers.isValidIDNumberSimple = (id) => {
  if (!id) return false;

  id = id.trim();

  // Must be exactly 10 digits and start with 1 or 2
  return /^[12][0-9]{9}$/.test(id);
}

Helpers.formatNumberJS = (num) => {
  let str = num.toString();
  // Remove leading "966" if present
  if (str.startsWith('966')) {
    str = str.slice(3);
  }

  const parts = [];

  for (let i = 0; i < str.length; i += 3) {
    parts.push(str.slice(i, i + 3));
  }

  // If last chunk is only 1 digit, merge it with previous
  if (parts.length > 1 && parts[parts.length - 1].length === 1) {
    parts[parts.length - 2] += parts.pop();
  }

  return parts.join(' ');
}

Helpers.formatStatusString = (str) => {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_'); // replaces one or more spaces
}

Helpers.hasEgyptFlexFeatureAttribute = (attr) => {
  if (!attr) {
    return false;
  }

  if (
    attr.Type === "IsEygptFlex" &&
    attr.List?.some((item) => String(item?.Value).toLowerCase() === "true")
  ) {
    return true;
  }

  const customAttributes = attr.CustomAttributes;
  if (customAttributes) {
    const egyptFlexFlag =
      customAttributes.IsEygptFlex ?? customAttributes.IsEgyptFlex;
    return String(egyptFlexFlag).toLowerCase() === "true";
  }

  return false;
};

Helpers.isEgyptFlexPlan = (plan) => {
  if (!plan) {
    return false;
  }

  if (
    plan.FeatureAttributes?.some((attr) =>
      Helpers.hasEgyptFlexFeatureAttribute(attr)
    )
  ) {
    return true;
  }

  return /egyptflex/i.test(plan.PlanCode ?? "");
};

Helpers.isEgyptFlexSelectedCard = (selectedCard) => {
  if (Helpers.isEgyptFlexPlan(selectedCard)) {
    return true;
  }

  if (!selectedCard?.PlanCode) {
    return false;
  }

  try {
    const storedDetail = Storage.get("pre-defined-plan-selected-detail", true);
    if (!storedDetail) {
      return false;
    }
    const parsedDetail = JSON.parse(storedDetail);
    return (
      parsedDetail?.PlanCode === selectedCard.PlanCode &&
      Helpers.isEgyptFlexPlan(parsedDetail)
    );
  } catch {
    return false;
  }
};

Helpers.parsePlanExtraDetails = (planDetails) => {
  if (!planDetails?.ExtraDetails) {
    return null;
  }
  try {
    return typeof planDetails.ExtraDetails === "string"
      ? JSON.parse(planDetails.ExtraDetails)
      : planDetails.ExtraDetails;
  } catch {
    return null;
  }
};

Helpers.isEgyptFlexFromPlanDetails = (planDetails) => {
  const extra = Helpers.parsePlanExtraDetails(planDetails);
  return extra ? Helpers.isEgyptFlexPlan(extra) : false;
};

Helpers.getPlanSpec = (plan, type) =>
  plan?.Plan?.find((item) => item.Type === type);

const EGYPT_FLEX_DEFAULT_SOCIAL_CHANNEL_CODES = [
  "WHATSAPP",
  "FACEBOOK",
  "YOUTUBE",
  "INSTA",
  "TWITTER",
  "SNAPCHAT",
];

const normalizeSocialChannels = (channels) => {
  if (!Array.isArray(channels)) {
    return [];
  }

  return channels
    .map((channel) => {
      const code = typeof channel === "string" ? channel : channel?.Code;
      return code ? { Code: String(code).trim().toUpperCase() } : null;
    })
    .filter(Boolean);
};

const extractSocialChannelsFromSocialPlan = (socialPlan) =>
  normalizeSocialChannels(socialPlan?.SocialChannels);

Helpers.resolveEgyptFlexSummarySource = (savedBundle, price) => {
  if (!savedBundle?.Plans?.length) {
    return null;
  }

  const plan = {
    PlanCode: savedBundle.PlanCode || "",
    Plan: savedBundle.Plans,
    FeatureAttributes: savedBundle.FeatureAttributes,
    PlanCardPrice: savedBundle.DiscountedPrice,
    DiscountedPrice: savedBundle.DiscountedPrice,
  };

  if (!Helpers.isEgyptFlexPlan(plan)) {
    return null;
  }

  return {
    plan,
    price: price ?? savedBundle.DiscountedPrice,
  };
};

Helpers.getSocialChannels = (plan) => {
  const socialPlan = Helpers.getPlanSpec(plan, "DATA-SOCIAL");
  let channels = extractSocialChannelsFromSocialPlan(socialPlan);

  if (!channels.length && socialPlan && Helpers.isEgyptFlexPlan(plan)) {
    channels = normalizeSocialChannels(EGYPT_FLEX_DEFAULT_SOCIAL_CHANNEL_CODES);
  }

  return channels;
};

const SOCIAL_CHANNEL_THEME_KEYS = {
  WHATSAPP: ["social_whatsapp"],
  FACEBOOK: ["social_facebook"],
  YOUTUBE: ["social_youtube"],
  INSTA: ["social_insta", "social_instagram"],
  INSTAGRAM: ["social_insta", "social_instagram"],
  TWITTER: ["social_twitter"],
  SNAPCHAT: ["social_snapchat"],
};

const SOCIAL_ICON_THEME_FOLDERS = ["social_networks", "pack_social_network"];

Helpers.getSocialNetworkIcon = (channelCode, lang) => {
  const normalizedCode = String(channelCode || "").trim().toUpperCase();
  if (!normalizedCode) {
    return "";
  }

  const keys = SOCIAL_CHANNEL_THEME_KEYS[normalizedCode] ?? [
    `social_${normalizedCode.toLowerCase()}`,
  ];

  for (const folder of SOCIAL_ICON_THEME_FOLDERS) {
    for (const key of keys) {
      const url = Helpers.getPOImageCommon(folder, key, lang, "");
      if (url) {
        return url;
      }
    }
  }

  return "";
};

Helpers.isUnlimitedPlanValue = (value) => value === -1;

Helpers.formatFeatureListValue = (raw) => {
  if (!raw || typeof raw !== "string") return "";
  return raw
    .replace(/_/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export default Helpers;
